<template>
      <v-col>
          <v-card flat>
         <v-data-table
            :key="componentKey"
            :headers="computedHeaders"
            :items="tableItems"
            class="elevation-1"
            :loading="clinicsLoadStatus===1"
            :options.sync="tableOptions"
            :server-items-length="options.lineCount"
            hide-default-footer
            must-sort
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Kliniki</v-toolbar-title>
                
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>
                

                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Wyszukaj"
                      single-line
                      hide-details
                      class="search"
                      @keydown.enter="searchClinics"
                  ></v-text-field>
                  </template>
                    <span>Wpisz min 3 znaki i naciśnij Enter</span>
                </v-tooltip>
                 

                <v-spacer></v-spacer>

                <v-checkbox v-model="showDeleted" class="mt-4" label="Pokaż wyłączone"></v-checkbox>

                <v-divider
                  v-if="user.permissions['clinics'] >= 10"
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>

                <v-tooltip v-if="user.permissions['clinics'] >= 10" right>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" :to="{name:'ustawienia.klinika',params:{}}" fab dark small><v-icon>mdi-plus</v-icon></v-btn>
                  </template>
                    <span>Dodaj rekord</span>
                </v-tooltip>

              </v-toolbar>
            </template>
            <template v-slot:item.type="{ item }">
              <span v-if="item.type">{{_.find(lookups.clinic_type,{'value':item.type}).text}}</span>
            </template>
             <template v-slot:item.address="{ item }">
              {{item.address}} {{item.house}}
            </template>
            <template v-slot:item.actions="{ item }">

                <v-tooltip v-if="item.status && user.permissions['clinics'] >= 10" right>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" :to="{name:'ustawienia.klinika',params:{id:item.id}}" icon><v-icon>mdi-pencil</v-icon></v-btn>
                  </template>
                    <span>Edytuj</span>
                </v-tooltip>

                <v-tooltip v-if="item.status && item.can_delete && user.permissions['clinics'] >= 10" right>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" @click="deleteItem(item)" icon><v-icon>mdi-delete</v-icon></v-btn>
                  </template>
                  <span>Wyłącz</span>
                </v-tooltip>

                <v-tooltip v-if="!item.status  && user.permissions['clinics'] >= 10" right>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" @click="reactivateItem(item)" icon><v-icon>mdi-delete-restore</v-icon></v-btn>
                  </template>
                  <span>Przywróć</span>
                </v-tooltip>

                <v-tooltip v-if="!item.status && item.can_delete  && user.permissions['clinics'] >= 10" right>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" @click="forceDeleteItem(item)" icon><v-icon color="error">mdi-delete-forever</v-icon></v-btn>
                  </template>
                  <span>Usuń na stałe</span>
                </v-tooltip>

                
            </template>

            <template v-slot:item.status="{ item }">
              <v-simple-checkbox v-model="item.status" disabled></v-simple-checkbox>
            </template>

          </v-data-table> 
          <div class="text-center pt-2">
            <v-btn @click="loadMore" v-if="!options.itemAdded && options.lineCount-tableItems.length>0 && clinicsLoadStatus===2" small color="primary"><v-icon left>mdi-download</v-icon>Załaduj więcej ({{ options.lineCount-tableItems.length }})</v-btn>
            <v-btn @click="loadClinics" v-else-if="options.itemAdded && options.lineCount-tableItems.length>0" small color="primary"><v-icon left>mdi-reload</v-icon>Odśwież tabele aby móc załadować więcej ({{ options.lineCount-tableItems.length }})</v-btn>
            <v-btn @click="loadClinics" v-else-if="options.itemSearched" small color="primary"><v-icon left>mdi-reload</v-icon>Anuluj wyszukiwanie</v-btn>
          
          </div>

          </v-card>
      
      <confirm ref="confirm"></confirm>
      </v-col>
      

</template>

<script>
  import confirm from '../components/Confirm'

  export default {
    props:{
      reload: Boolean
    },
    components:{
      confirm,
    },
    data: () => ({
      componentKey:0,
      tableOptions: {},
      dialog: false,
      search:'',
      headers: [
        { text: '',align: 'start',sortable: false,value: 'lp',filterable:false,visible:true},
        { text: 'Nazwa kliniki/oddziału', value: 'name',filterable:true,filterColumn:"name",visible:true},
        { text: 'Rodzaj', value: 'type',filterable:true,filterColumn:"type",visible:true},
        { text: 'Miasto', value: 'city',filterable:false,filterColumn:"city",visible:true},
        { text: 'Adres', value: 'address',filterable:false,filterColumn:"address",visible:true},
        { text: 'Status', value: 'status',filterable:false,filterColumn:"status",visible:true},
        { text: '', value: 'actions', sortable: false,filterable:false,visible:true},
      ],
    }),
    watch: {
      tableOptions: {
        handler () {
          var currentOptions = {...this.options};
          const { sortBy, sortDesc } = this.tableOptions
        
          //zmiana sortowania
          if (sortBy.length === 1 && sortDesc.length === 1) {
            currentOptions.orderBy = sortBy[0];
            currentOptions.orderDirection = sortDesc[0]?'desc':'asc';
            this.options = currentOptions;
          } 
        },
        deep: true,
      },
    
      dialog (val) {
        val || this.close()
      },
      clinicEditStatus(val){
        if(val===2){
          this.componentKey += 1;
        }
      },
      clinicAddStatus(val){
        if(val===2){
          this.componentKey += 1;
        }
      },
      clinicDeleteStatus(val){
        if(val===2){
          this.componentKey += 1;
        }
      }
    },
    computed: {
      user(){
        return this.$store.getters.getUser;
      },
      lookups(){
        return this.$store.getters.getLookups;
      },
      options:{
        get () {  
          return this.$store.getters.getClinicOptions;
        },
        set (value) {
          this.search='';
          this.$store.dispatch( 'setClinicOptions', {options:value} )
        }
      },
      showDeleted: {
        get () {
          return this.$store.getters.getClinicOptions.showDeleted;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.showDeleted = value;
          this.options = currentOptions;
        }
      },
      editedItem(){
        return this.$store.getters.getClinicEdit;
      },
      tableItems(){
        return this.$store.getters.getClinics;
      },
      clinicsLoadStatus(){
        return this.$store.getters.getClinicsLoadStatus;
      },
      clinicEditLoadStatus(){
        return this.$store.getters.getClinicEditLoadStatus
      },
      clinicEditStatus(){
        return this.$store.getters.getClinicEditStatus();
      },
      clinicAddStatus(){
        return this.$store.getters.getClinicAddStatus();
      },
      clinicDeleteStatus(){
        return this.$store.getters.getClinicDeleteStatus();
      },
      computedHeaders () {
        var h = _.filter(this.headers,function(o) { return o.visible; })

        // if(!this.showDeleted && this.user.permissions['clinics'] <= 5) return h.filter(h => h.value!=='status' && h.value!=='actions')
        // else if(this.showDeleted && this.user.permissions['clinics'] <= 5) return h.filter(h => h.value!=='actions')
        // else 
        if(!this.showDeleted) return h.filter(h => h.value!=='status')
        else return h
      },
    },
    mounted(){
      if(this.reload)this.loadClinics();
    },
    methods: {
      loadClinics(){
        this.search='';
        this.$store.dispatch( 'loadClinics' );
      },
      loadMore(){
        this.$store.dispatch( 'loadMoreClinics' );
      },
      reactivateItem(item){
        this.$store.dispatch( 'editClinicReactivate',{slug:item.id});
      },
      deleteItem (item) {
        this.$refs.confirm.open('Usuń', 'Czy na pewno chcesz wyłączyć klinikę?', { color: 'error' }).then((confirm) => {
            if(confirm){
               this.$store.dispatch( 'deleteClinic', {slug:  item.id});
            }
        })
      },
      forceDeleteItem (item) {
        this.$refs.confirm.open('Usuń', 'Czy na pewno chcesz usunać klinikę na stałe?', { color: 'error' }).then((confirm) => {
            if(confirm){
               this.$store.dispatch( 'forceDeleteClinic', {slug:  item.id});
            }
        })
      },
      searchClinics(){
        if(this.search.length>2){
          const filterableHeaders = _.join(_.map(_.filter(this.headers,{'filterable':true}),'filterColumn'),';');
          this.$store.dispatch( 'searchClinics',{filterableHeaders:filterableHeaders,q:this.search});
        }
      },
    },
  }
</script>


<style scoped>
.search{
      max-width: 250px;
}
</style>